import { Directive } from "@angular/core";
import { UntypedFormControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";
import { AceValidators } from "@app/shared/util/validators/ace-validators";

@Directive({
  selector: '[appValidEmailValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: ValidEmailValidatorDirective, multi: true}],
  standalone: false
})
export class ValidEmailValidatorDirective implements Validator {

  validate(control: UntypedFormControl): ValidationErrors | null {
    return AceValidators.emailValidator()(control);
  }
}
